import { useMemo } from 'react';
import styled from 'styled-components';
import { useBreakpoints } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { Deactivation, StyledFreeLink, useTheme } from '../../common';
import { BigImage, Full, Small } from './widget-types';

export function Embed() {
  const { widgetWidth, font, sourceType } = useSettings();
  const { textColor, backgroundStyle } = useTheme();
  const [breakpoints, containerRef] = useBreakpoints(520, 440);

  const component = useMemo(() => {
    if (breakpoints[440]) {
      return <BigImage />;
    }

    if (sourceType !== 'radio' && breakpoints[520]) {
      return <Small showControlsInOneLine />;
    }

    return <Full />;
  }, [breakpoints, sourceType]);

  return (
    <Deactivation>
      <Container
        _backgroundStyle={backgroundStyle}
        _color={textColor}
        _font={font?.value || 'inherit'}
      >
        <Inner ref={containerRef} _widgetWidth={widgetWidth.toString()}>
          {component}
        </Inner>
        <StyledFreeLink />
      </Container>
    </Deactivation>
  );
}

const Container = styled.div<{
  _color: string;
  _font: string;
  _backgroundStyle?: string;
}>`
  width: 100%;
  color: ${({ _color }) => _color};
  font-family: ${({ _font }) => _font};

  ${({ _backgroundStyle }) => _backgroundStyle};
`;

const Inner = styled.div<{
  _widgetWidth: string;
}>`
  width: 100%;
  margin: 0 auto;
  max-width: ${({ _widgetWidth }) =>
    _widgetWidth.includes('%') ? _widgetWidth : `${_widgetWidth}px`};
`;
